import Rest from './rest';

const AUTH_RESOURCE = "editor/auth";

export default {

    auth: function (objectParams) {
        return Rest.post(AUTH_RESOURCE, objectParams, false);
    },
};



// WEBPACK FOOTER //
// ./src/services/AuthService.js